class Str {
  static removeAllWhitespaces(subject) {
    if (!subject) return subject;
    return subject.replace(/\s+/g, '');
  }
}
export default Str;
